
class TypeaheadObject {

	constructor(field, value, fieldLabel, valueLabel) {
		this.isSeparator = false;
		this.field = field;
		this.value = value;
		this.fieldLabel = fieldLabel;
		this.valueLabel = valueLabel;

	}

    setSeparator(isSeparator) {
        this.isSeparator = isSeparator;
    }

		/* istanbul ignore next */
    getValue() {
        return this.value;
    }

		/* istanbul ignore next */
    getField() {
        return this.field;
    }

		/* istanbul ignore next */
    getValueLabel() {
        return this.valueLabel || this.value;
    }

		/* istanbul ignore next */
    getFieldLabel() {
        return this.fieldLabel || this.field;
    }
};



class SearchFilter {

	constructor(field, value, fieldLabel, valueLabel) {
		this.field = field;
		this.value = value;
		this.fieldLabel = fieldLabel;
		this.valueLabel = valueLabel;
	}

    getValue() {
        return this.value;
    }

    getField() {
        return this.field;
    }

    getValueLabel() {
        return this.valueLabel || this.value;
    }

    getFieldLabel() {
        return this.fieldLabel || this.field;
    }
};

class SearchRequest {

	constructor() {
        this.query = "";
        this.classifications = [];
        this.filters = [];

        this.rootPath = "?";
        this.sortField = "lastModified";
        this.sortDirection = "desc";
        /** how many rows each query return */
        this.rows = 20;
        /** the query start index */
        this.start = 0;

        this.typeaheadQueryTemplate = 'q=*"$query$"*&defType=edismax&facet.contains=$query$&rows=0&facet.contains.ignoreCase=true&qf=id+name%5E20+type%5E10+assetType+tags+status+locale+categoryLeaves+keywords+text+text_ar+text_cjk+text_da+text_de+text_el+text_en+text_es+text_fi+text_fr+text_he+text_hi+text_it+text_ja+text_nl+text_no+text_pl+text_pt+text_pt_br+text_ru+text_sv+text_th+text_tr+text_zh_cn&fq=classification:(content%20OR%20asset)&fq=isManaged:("true")&facet=on&facet.mincount=1&facet.limit=3&facet.field=name&facet.field=assetType&facet.field=type&facet.field=tags&facet.field=status&facet.field=locale&facet.field=categoryLeaves&facet.field=keywords';
        this.fulltextQueryTemplate = "q=*$query$*&defType=edismax&indent=on&qf=name%5E15+description+creator+lastModifier+tags+status%5E20+path&wt=json&facet.field=created&facet.field=lastModified&facet.field=tags&facet.range=created&facet.range=lastModified&f.created.facet.mincount=0&f.lastModified.facet.mincount=0&facet.range.start=NOW/DAY-30DAYS&facet.range.end=NOW&facet.range.gap=%2B1DAY";
        this.facetFields = ["name", "assetType", "type", "tags", "status", "locale", "categoryLeaves", "keywords"];
	}


    getQuery() {
        return this.query;
    }

    setQuery(query) {
        this.query = query;
    }

    getFilters() {
        return this.filters;
    }

    setFilters(filters) {
        this.filters = filters;
    }

    getClassification() {
        return this.classifications;
    }

    setClassifications(classification) {
        this.classifications = classification;
    }

    setSortField(field) {
        this.sortField = field;
    }

    setSortDirection(direction) {
        const direct = direction.toLowerCase();
        if (direct === 'desc' || direct === 'asc') {
            this.sortDirection = direct;
        }
    }

    setRows(rows) {
        this.rows = rows;
    }

    getRows() {
        return this.rows;
    }

    setStart(start) {
        this.start = start;
    }

    getStart() {
        return this.start;
    }

    getFullTextSearchString() {
    	var input = this.query;
        let queryString = this.rootPath;
        if (input != null && input.trim() !== "") {
            queryString += this.fulltextQueryTemplate.replace(/\$query\$/g, encodeURIComponent(input));
        } else {
            queryString += this.fulltextQueryTemplate.replace(/\$query\$/g, ":");
        }
        return queryString + this.sortString() + this.classificationString() + this.filterString() + this.facetsString() + this.sortString() + this.rowsString() + this.timezone();
    }

    getTypeaheadSearchString(input) {
        if (input != null && input.trim().length > 0) {
             return this.rootPath + this.typeaheadQueryTemplate.replace(/\$query\$/g, encodeURIComponent(input)) + this.classificationString() + this.filterString();
        }
    }

    getFacetOfField(field, input) {
        if (input != null && field != null) {
            let query = this.rootPath + "facet=true&facet.field=" + field + this.filterString();
            if (input.trim().length > 0) {
                query += "&facet.contains=" + encodeURIComponent(input);
            }
            return query;
        }
    }

    rowsString() {
        return "&rows=" + this.rows + "&start="+ this.start;
    }

    timezone() {
        return "";
    }
    /**
     * Generate the sort query string
     * @returns {string}
     */
    sortString() {
        return "&sort=" + encodeURIComponent(this.sortField + " " + this.sortDirection);
    }

    /**
     * Generate facet query string
     */
    facetsString() {
        let str = "";
        const facetFields = this.getValidFacetsFields();
        if (facetFields != null && facetFields.length > 0) {
            str = "&facet=true&facet.mincount=1&facet.limit=30";
            facetFields.forEach(function(value) {
                str += "&facet.field=" + value;
            });
        }
        return str;
    }

    /**
     *
     * @param filters An array of Filter object in format {field: xxx, name: xxx}
     */
    filterString() {
        let filtesrStr = "";
        if (this.filters != null) {
            this.filters.forEach(function(value) {
                filtesrStr += "&fq=" + value.getField() + ":" + encodeURIComponent(value.getValue());
            });
        }
        return filtesrStr;
    }

    classificationString() {
        let classStr = "";
        if (this.classifications != null && this.classifications.length > 0) {
            classStr = "&fq=classification:(" + encodeURIComponent(this.classifications.join(" OR ")) + ")";
        }
        return classStr;
    }
    /**
     * Remove those facet field that already have filter assigned to get the valid facet field
     * for next search, improve the serch performance.
     * @returns {string[]}
     */
    getValidFacetsFields() {
        let facets = this.facetFields;
        if (this.filters && this.filters.length > 0) {
            const filters = this.filters.map(function(element) {
                return element.getField();
            });
            facets = this.facetFields.filter(function(value) {
                return filters.indexOf(value) < 0 || value === "tags";
            });
        }
        return facets;
    };
};


/**
 * Transformer of the search result from search service
 */
class SearchResult {

	constructor(result) {
        this.documents = [];
        this.numFound = 0;
        this.facets = new SearchFacets({}, {}, 0);

        const resultJson = (result.data ? result.data : result);
        if (resultJson) {
            if (resultJson.documents != null) {
                // this could happen for pure facet search
                resultJson.documents.forEach(function(element){
                    element.id = element.id.substring(element.id.lastIndexOf("-") + 1);
                });
            }
            this.documents = resultJson.documents == null ? [] : resultJson.documents;
            this.numFound = resultJson.numFound;
            this.facets = new SearchFacets(resultJson.facets == null ? {} : resultJson.facets, resultJson.facet_ranges == null ? {} : resultJson.facet_ranges, this.numFound);
        } else {
            this.documents = [];
            this.numFound = 0;
            this.facets = new SearchFacets({}, {}, 0);
        }
	}

    /**
     * documents
     * @returns {any}
     */
    getDocuments() {
        return this.documents;
    }

    /**
     * Facets
     * @returns {SearchFacets}
     */
    getFacets() {
        return this.facets;
    }

    getNumFound() {
        return this.numFound;
    }

};


/**
 * Facet value, like
 * Red: 123
 */
class FacetValue {

	constructor(value, count) {
		this.value = value;
		this.count = count;
		this.label = "";
	}

    getValue() {
        return this.value;
    }

    getCount() {
        return this.count;
    }

		/* istanbul ignore next */
    setLabel(label) {
        this.label = label;
    }

		/* istanbul ignore next */
    getLabel() {
        return this.label || this.value;
    }
};




/**
 * One Facet field, like
 * classification {
 *      content: 130,
 *      content-type: 200,
 *      asset: 300
 * }
 */
class SearchFacet {

	constructor(field, values) {
		this.field = field;
		this.values = values;
	}

		/* istanbul ignore next */
    add(value) {
        this.values.push(value);
    }

		/* istanbul ignore next */
    getField() {
        return this.field;
    }

    getValues() {
        return this.values;
    }

		/* istanbul ignore next */
    getCount(value){
        for ( var facetValue of this.values) {
            if (value === facetValue.getValue()) {
                return facetValue.getCount();
            }
        }
        return -1;
    }

		/* istanbul ignore next */
    isEmpty() {
        return this.values == null || this.values.length === 0;
    }
};



/**
 * Facets in a search result.
 */
class SearchFacets {

	constructor(facets, ranges, numFound) {
	    this.facetMap = this.parseFacetsResult(facets);
		this.ranges = new SearchFacetRanges(ranges, numFound);;
		this.numFound = numFound;

	    this.emptyFacet = new SearchFacet("empty", []);
	}

    getFacet(field) {
        if (field && this.facetMap[field]) {
            return this.facetMap[field];
        } else {
            return this.emptyFacet;
        }
    }

    getFacets() {
        return this.facetMap;
    }


    /**
     * Facet ranges
     * @returns {SearchFacetRanges}
     */
		 /* istanbul ignore next */
    getFacetRanges() {
        return this.ranges;
    }

		/* istanbul ignore next */
    getResultCount() {
        return this.numFound;
    }

    parseFacetsResult(facets) {
        var result = {};
        for (var field in facets) {
            if (facets.hasOwnProperty(field) && facets[field] && Array.isArray(facets[field]) && facets[field].length > 0) {
                var facet = facets[field];
                var valueArray = [];
                for (let i = 0; i < facet.length; i = i + 2) {
                    valueArray.push(new FacetValue(facet[i], facet[i + 1]));
                }
                result[field] = new SearchFacet(field, valueArray);
            }
        }
        return result;
    }
};



/**
 * Facet range object, like
 * last week: 20
 */
class Range {

	constructor(label, field, start, end, count) {
		this.label = label;
		this.field = field;
		this.start = start;
		this.end = end;
		this.count = count;
	}

		/* istanbul ignore next */
    getValue() {
        return "[" + this.start + " TO " + this.end + "]";
    }

		/* istanbul ignore next */
    getLabel() {
        return this.label;
    }

		/* istanbul ignore next */
    setLabel(label) {
        return this.label = label;
    }

		/* istanbul ignore next */
    getCount() {
        return this.count;
    }

		/* istanbul ignore next */
    getField() {
        return this.field;
    }
};




/**
 * One facet range result. like
 * created: [{Today...},{This week...}]
 */
class SearchFacetRange {

	constructor(field, values, numFound) {
		this.field = field;
		this.values = values;
		this.numFound = numFound;
		this.result = [];

        this.calculate();
	}

		/* istanbul ignore next */
    getField() {
        return this.field;
    }

		/* istanbul ignore next */
    getResult() {
        return this.result;
    }


    calculate() {
        if (this.values && this.values.length > 0) {
            /* TEMP commented out --> need to import moment to get this to work
			const dayOfWeek = moment().day();
            const dayOfLastWeek = moment().day() + 7;
            const dayOfMonth = moment().date(); */
			// TEMP WORKAROUND
			const dayOfWeek = 0;
            const dayOfLastWeek = 7;
            const dayOfMonth = 5;

            let sum = 0;
            let countThisWeek = 0;
            let totalThisMonth = 0;

            /**  define each of separately to keep the order */
            let today, yesterday, thisWeek, lastWeek, thisMonth, before;
            for (let i = 0; i < this.values.length; i++) {
                sum += this.values[i].getCount();
                // Calculate
								/* istanbul ignore else */
                if (i === 0 && this.values[i].getCount() > 0) {
                    today = new Range(SearchFacetRange.RANGE_TODAY, this.field, "NOW/DAY", SearchFacetRange.NOW, this.values[i].getCount());
                }
								/* istanbul ignore next */
                if (i === 1 && this.values[i].getCount() > 0) {
                    yesterday = new Range(SearchFacetRange.RANGE_YESTERDAY, this.field, "NOW/DAY-1DAY", "NOW/DAY", this.values[i].getCount());
                }
								/* istanbul ignore next */
                if (i === (dayOfWeek - 1)) {
                    countThisWeek = sum;
                    if (sum > 0) {
                        thisWeek = new Range(SearchFacetRange.RANGE_THIS_WEEK, this.field, "NOW/DAY-" + dayOfWeek + "DAY", SearchFacetRange.NOW, sum);
                    }
                }
								/* istanbul ignore next */
                if (i === (dayOfLastWeek - 1) && (sum - countThisWeek > 0 )) {
                    lastWeek = new Range(SearchFacetRange.RANGE_LAST_WEEK, this.field, "NOW/DAY-" + dayOfLastWeek + "DAY", "NOW/DAY-" + dayOfWeek + "DAY", sum - countThisWeek);
                }
								/* istanbul ignore next */
                if (i === (dayOfMonth - 1)) {
                    totalThisMonth = sum;
                    if (sum > 0) {
                        thisMonth = new Range(SearchFacetRange.RANGE_THIS_MONTH, this.field, "NOW/MONTH", SearchFacetRange.NOW, sum);
                    }
                    break;
                }
            }
						/* istanbul ignore if */
            if (this.values.length > dayOfMonth && (this.numFound - totalThisMonth > 0)) {
                before = new Range(SearchFacetRange.RANGE_BEFORE, this.field, "*", "NOW/MONTH", this.numFound - totalThisMonth);
            }

            this.result = [];
            // have to do this to keep the order, otherwise yesterday could show up after this week if it's Monday
            // can be done by array.map but keep it as simple as possible to make it easy to understand.
            if (today != null) {
                this.result.push(today);
            }
						/* istanbul ignore next */
            if (yesterday != null) {
                this.result.push(yesterday);
            }
						/* istanbul ignore next */
            if (thisWeek != null) {
                this.result.push(thisWeek);
            }
						/* istanbul ignore next */
            if (lastWeek != null) {
                this.result.push(lastWeek);
            }
						/* istanbul ignore next */
            if (thisMonth != null) {
                this.result.push(thisMonth);
            }
						/* istanbul ignore next */
            if (before != null) {
                this.result.push(before);
            }
        }
    }
};

/*
 * These need to be translated.
 */
const RANGE_TODAY = "today";
const RANGE_YESTERDAY = "yesterday";
const RANGE_THIS_WEEK = "thisWeek";
const RANGE_LAST_WEEK = "lastWeek";
const RANGE_THIS_MONTH = "thisMonth";
const RANGE_BEFORE = "beforeThisMonth";
const NOW = "NOW/DAY+1DAY";




/**
 * Search Range Facet result, like
 * {
 *      created: [rangeA, rangeB...]
 *      modified: [rangeC, rangeD...]
 * }
 */
class SearchFacetRanges {

	constructor(ranges, numFound) {
	    this.map = {};
	    this.emptyRangeFacet = new SearchFacetRange("empty", [], 0);

        if (ranges != null) {
            this.map = this.parseFacetRangeResult(ranges);
        }
        this.numFound = numFound;
	}

    /**
     * Get the SearchFacetRanage
     * @param field the facet field
     * @returns a SearchFacetRange object
     */
		 /* istanbul ignore next */
    getRange(field) {
        if (field && this.map[field]) {
            return this.map[field];
        } else {
            return this.emptyRangeFacet;
        }
    }

    /**
     * Parse the range facet result from array of key&number to a Array of SearchFacetRange
     * Also reverse the order to make it easier to calculate the count
     * @param facets
     * @returns {{}}
     */
    parseFacetRangeResult(facets) {
        var result = {};
        for (var field in facets) {
            if (facets.hasOwnProperty(field) && facets[field] && facets[field].counts && Array.isArray(facets[field].counts) && facets[field].counts.length > 0) {
                    var facet = facets[field].counts;
                    var valueArray = [];
                    /*
                     Reverse the order
                     */
                    for (let i = facet.length - 1; i > -1; i = i - 2) {
                        valueArray.push(new FacetValue(facet[i - 1], facet[i]));
                    }
                    result[field] = new SearchFacetRange(field, valueArray, this.numFound);
            }
        }
        return result;
    }
};


class SearchTransformerService {

	SearchRequest() {
		return new SearchRequest();
	}

	SearchResult(data) {
		return new SearchResult(data);
	}

	SearchFilter(field, value, fieldLabel, valueLabel) {
		return new SearchFilter(field, value, fieldLabel, valueLabel);
	}

    /**
     * Facets result is in format like
     * {
     *    "name": [
     *      "article"
     *    ],
     *    "creator": [
     *      "carlos",
     *      "evan"
     *    ],
     *    "status": [
     *      "draft"
     *    ]
     *  }
     *
     *  And in order to make it has meaning for typeahead, transform is needed.
     * @param facets
     */
	transformFacetsIntoTypeahead(facets) {
		var result = [];
		if (facets != null) {
			for ( var key in facets.getFacets()) {
				if (facets.getFacets().hasOwnProperty(key)) {
                    let taObj;
                    var facetArray = facets.getFacet(key).getValues();
					for ( let i = 0; i < facetArray.length; i++) {
						taObj = new TypeaheadObject(key, facetArray[i].getValue(), key);
						if (i === 0) {
							taObj.setSeparator(true);
						}
						result.push(taObj);
					}
				}
			}
		}
		return result;
	}


};

angular
.module('HomepageServices')
.service('SearchTransformerService', SearchTransformerService);



// WEBPACK FOOTER //
// ./app/common/searchTransformerService.js